import { NavLink } from 'react-router-dom';

const Sidebar = () => (
  <div className="sidebar">
    <h4>Stolity Admin</h4>
    <NavLink to="/dashboard" className={({isActive}) => isActive ? "active" : ""}>Dashboard</NavLink>
    <NavLink to="/users" className={({isActive}) => isActive ? "active" : ""}>Users</NavLink>
    <NavLink to="/domain-data" className={({isActive}) => isActive ? "active" : ""}>Domain Data</NavLink>
  </div>
);

export default Sidebar;